import { Box } from "@mui/material";
import { TaskerMessage, TaskerConfig } from "@t3/shared";
import { MessagesByDay } from "../MyMessagesTypes";
import { TaskerMessageCard } from "../../TaskerMessageCard";

export const TaskerMessageCardList = ({
  messagesByDay,
  selectedDay,
  userTaskerConfigs,
}: {
  messagesByDay: MessagesByDay;
  selectedDay: string;
  userTaskerConfigs: TaskerConfig[];
}) => {
  return (
    <Box sx={{ px: "10px", minWidth: 0, width: "100%" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: "10px",
          pb: "10px",
          width: "100%",
          minWidth: 0,
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        {messagesByDay[selectedDay].messages.map((message: TaskerMessage) => (
          <TaskerMessageCard
            key={message.id}
            message={message}
            size="100%"
            showContactInfo={false}
            userTaskerConfigs={userTaskerConfigs}
          />
        ))}
      </Box>
    </Box>
  );
};
